import type {ColumnSet} from 'services/advancedSearch/types';

export const mapColumnSetToOption = (columnSet: ColumnSet) => ({
  value: columnSet.id,
  label: columnSet.name,
});
